import { connect } from 'react-redux';
import { tryNavigateTo } from '../../actions/navigation';
import { getPrice } from '../../selectors/index';
import { getLocationName } from '../../selectors/bookingLocation';
import { getDiscount } from '../../selectors/discount';
import Pay from './Pay';
import { AppStep } from '../../reducers/navigation';

function toFixed(num, fixed) {
  // eslint-disable-next-line
  var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  return num.toString().match(re)[0];
}

const mapStateToProps = (state) => {
    
  // Purely used for statistical purposes:
  const discountInfo = getDiscount(state);
  const priceInfo = getPrice(state, discountInfo);
  const subTotal = Math.max(priceInfo.basePrice - priceInfo.discount, 0);
  const total = toFixed(subTotal + priceInfo.tax - state.giftCard.total_amount, 2);

  return {
    cartValue: total ? total : '',
    locationCurrency: state.bookingLocation.selectedLocation.currency ? state.bookingLocation.selectedLocation.currency : '',
    locationName: state.bookingLocation.selectedLocation ? getLocationName(state.bookingLocation.selectedLocation) : '',
    selectedDate: state.date.selectedDate || new Date(),
    sessionToken: state.checkout.sessionToken,
    signedAuthorizationRequest: state.checkout.signedAuthorizationRequest,
    purchaseCode: state.checkout.purchaseCode,
    emailAddress: state.checkout.email,
    firstName: state.checkout.firstName,
    lastName: state.checkout.lastName,

    cusNumber: state.checkout.cusNumber,
    provinciaId: state.checkout.provinciaId,
    cantonId: state.checkout.cantonId,
    distritoId: state.checkout.distritoId,
    barrioId: state.checkout.barrioId,
    direccion: state.checkout.direccion,
    tipoIdent: state.checkout.tipoIdent,
    tipoDoc: state.checkout.tipoDoc,
    areaTelefono: state.checkout.areaTelefono,
    numTelefono: state.checkout.numTelefono,
    correo: state.checkout.correo,
    fullName: state.checkout.fullName,

    languageObj: state.language.pay_js
  };
};

const mapDispatchToProps = (dispatch) => ({
  transitionBack: () => dispatch(tryNavigateTo(AppStep.Checkout))
});

export default connect(mapStateToProps, mapDispatchToProps)(Pay);
